
import { defineComponent, computed, ref } from 'vue'
import { IonPage, IonContent } from '@ionic/vue'
import CalendarGrid from '@/components/organisms/calendar/CalendarGrid.vue'
import { Dayjs } from 'dayjs'
import CalendarPageModal from '@/components/organisms/calendar/CalendarPageModal.vue'
import { onBeforeRouteLeave } from 'vue-router'
import { provideCalendarBaseModule } from '@/provider/CalendarBaseModule'
import { provideCalendarPageModule } from '@/provider/CalendarPageModule'
import MyHeader from '@/components/layouts/MyHeader.vue'

export default defineComponent({
  components: {
    IonContent,
    IonPage,
    CalendarGrid,
    CalendarPageModal,
    MyHeader,
  },
  setup() {
    const { currentMonth, calendarPages } = provideCalendarBaseModule()
    provideCalendarPageModule()
    const calendarPageModalDate = ref<Dayjs | null>(null)
    const setCalendarPageModalDate = (date: Dayjs | null) => {
      calendarPageModalDate.value = date
    }
    onBeforeRouteLeave(() => {
      setCalendarPageModalDate(null)
    })
    const totalPrice = computed(() => {
      return (
        calendarPages.value
          ?.flat()
          .reduce((acc, cur) => (cur?.totalPrice || 0) + acc, 0) ?? 0
      )
    })

    return {
      currentMonth,
      totalPrice,
      calendarPageModalDate,
      setCalendarPageModalDate,
    }
  },
})
